import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { prettyStatusNames } from './consignments.constants';
import { snakeToPretty } from '../../library/lodash-helper';
import { loadObjectMetadata } from '../../actions/objectmetadata-actions';

interface StatusPrettyNameProps {
    status: string;
    useMariaDb?: boolean;
}

const OBJECT_TYPE = 'CONSIGNMENT';

const StatusPrettyName: React.FC<StatusPrettyNameProps> = ({ status, useMariaDb }) => {
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const language = i18n.language;
    const objectMetadata = useSelector(
        (state: any) => state.genericPage?.objectMetadata?.[OBJECT_TYPE],
    );
    const isLoading = useSelector(
        (state: any) => state.genericPage?.objectMetadataLoading,
    );

    useEffect(() => {
        if (!objectMetadata && !isLoading) {
            dispatch(loadObjectMetadata(OBJECT_TYPE) as any);
        }
    }, [objectMetadata, isLoading]);

    const customEventMap = useMemo(() => {
        const map: Record<string, any> = {};
        if (objectMetadata?.events) {
            objectMetadata.events.forEach((event: any) => {
                if (event.isActive !== false) {
                    map[event.id] = event;
                }
            });
        }
        return map;
    }, [objectMetadata]);

    if (!status) return <>{status}</>;

    const event = customEventMap[status];

    if (language && event?.prettyNameOverrides?.[language]) {
        return <>{event.prettyNameOverrides[language]}</>;
    }

    if (event?.isCustom && event?.prettyName) {
        return <>{event.prettyName}</>;
    }

    if (prettyStatusNames[status]) {
        return <>{prettyStatusNames[status]}</>;
    }

    return <>{useMariaDb ? status : snakeToPretty(status)}</>;
};

export default React.memo(StatusPrettyName);
